// @ts-nocheck
import * as Types from '../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import * as ApolloReactCommon from 'src/apolloHooks';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type ProductOfferingVersionHistoryQueryVariables = Types.Exact<{
  filter: Types.ReadyPlanAggregateVersionsFilter;
  page: Types.PageFilter;
}>;


export type ProductOfferingVersionHistoryQuery = { __typename?: 'Query', readyPlanAggregateVersionsPage: { __typename?: 'ReadyPlanAggregateVersionsPageResult', entities: Array<{ __typename?: 'ReadyPlanAggregateVersion', id: string, version?: number | null | undefined, versionNotes?: string | null | undefined, publishedAt?: Types.Scalars['DateTime']['input'] | null | undefined, status: { __typename?: 'AggregateVersionStatusDetail', code: Types.AggregateVersionStatus }, readyPlan:
        | { __typename?: 'ReadyPlan', id: string, name: string }
        | { __typename?: 'PlanPackage', id: string, name: string }
        | { __typename?: 'DesignPackage', id: string, name: string }
        | { __typename?: 'ProductOffering', id: string, name: string }
      , tlivChangeSummary: Array<{ __typename?: 'TlivChangeSummary', changeType: string, total: number, byLocation: Array<{ __typename?: 'TlivLocationCount', count: number, location: { __typename?: 'Location', id: string, name: string } }> }>, productTlivChangeSummary: Array<{ __typename?: 'TlivChangeSummary', changeType: string, total: number, byLocation: Array<{ __typename?: 'TlivLocationCount', count: number, location: { __typename?: 'Location', id: string, name: string } }> }> }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean } } };

export type ProductOfferingVersionTlivDetailsQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type ProductOfferingVersionTlivDetailsQuery = { __typename?: 'Query', readyPlanAggregateVersion: { __typename?: 'ReadyPlanAggregateVersion', id: string, tliVersions: Array<{ __typename?: 'TakeoffLineItemVersion', id: string, changeType: string, location: { __typename?: 'Location', id: string, effectiveLocation: { __typename?: 'Location', id: string, name: string } }, materialVariant?: { __typename?: 'MaterialVariant', id: string, displayName: string } | null | undefined, identity: { __typename?: 'TakeoffLineItem', id: string, isProductMaterial: boolean, item: { __typename?: 'Item', id: string, name: string } } }> } };

export type ProductOfferingVersionHistory_VersionFragment = { __typename?: 'ReadyPlanAggregateVersion', id: string, version?: number | null | undefined, versionNotes?: string | null | undefined, publishedAt?: Types.Scalars['DateTime']['input'] | null | undefined, status: { __typename?: 'AggregateVersionStatusDetail', code: Types.AggregateVersionStatus }, readyPlan:
    | { __typename?: 'ReadyPlan', id: string, name: string }
    | { __typename?: 'PlanPackage', id: string, name: string }
    | { __typename?: 'DesignPackage', id: string, name: string }
    | { __typename?: 'ProductOffering', id: string, name: string }
  , tlivChangeSummary: Array<{ __typename?: 'TlivChangeSummary', changeType: string, total: number, byLocation: Array<{ __typename?: 'TlivLocationCount', count: number, location: { __typename?: 'Location', id: string, name: string } }> }>, productTlivChangeSummary: Array<{ __typename?: 'TlivChangeSummary', changeType: string, total: number, byLocation: Array<{ __typename?: 'TlivLocationCount', count: number, location: { __typename?: 'Location', id: string, name: string } }> }> };

export type ProductOfferingTlivChangeSummaryFragment = { __typename?: 'TlivChangeSummary', changeType: string, total: number, byLocation: Array<{ __typename?: 'TlivLocationCount', count: number, location: { __typename?: 'Location', id: string, name: string } }> };

export type ProductOfferingTlivDetailsFragment = { __typename?: 'TakeoffLineItemVersion', id: string, changeType: string, location: { __typename?: 'Location', id: string, effectiveLocation: { __typename?: 'Location', id: string, name: string } }, materialVariant?: { __typename?: 'MaterialVariant', id: string, displayName: string } | null | undefined, identity: { __typename?: 'TakeoffLineItem', id: string, isProductMaterial: boolean, item: { __typename?: 'Item', id: string, name: string } } };

export const ProductOfferingTlivChangeSummaryFragmentDoc = gql`
    fragment ProductOfferingTlivChangeSummary on TlivChangeSummary {
  changeType
  total
  byLocation {
    location {
      id
      name
    }
    count
  }
}
    `;
export const ProductOfferingVersionHistory_VersionFragmentDoc = gql`
    fragment ProductOfferingVersionHistory_Version on ReadyPlanAggregateVersion {
  id
  version
  versionNotes
  status {
    code
  }
  publishedAt
  readyPlan {
    id
    name
  }
  tlivChangeSummary {
    ...ProductOfferingTlivChangeSummary
  }
  productTlivChangeSummary {
    ...ProductOfferingTlivChangeSummary
  }
}
    ${ProductOfferingTlivChangeSummaryFragmentDoc}`;
export const ProductOfferingTlivDetailsFragmentDoc = gql`
    fragment ProductOfferingTlivDetails on TakeoffLineItemVersion {
  id
  changeType
  location {
    id
    effectiveLocation {
      id
      name
    }
  }
  materialVariant {
    id
    displayName
  }
  identity {
    id
    isProductMaterial
    item {
      id
      name
    }
  }
}
    `;
export const ProductOfferingVersionHistoryDocument = gql`
    query ProductOfferingVersionHistory($filter: ReadyPlanAggregateVersionsFilter!, $page: PageFilter!) {
  readyPlanAggregateVersionsPage(filter: $filter, page: $page) {
    entities {
      ...ProductOfferingVersionHistory_Version
    }
    pageInfo {
      hasNextPage
    }
  }
}
    ${ProductOfferingVersionHistory_VersionFragmentDoc}`;

/**
 * __useProductOfferingVersionHistoryQuery__
 *
 * To run a query within a React component, call `useProductOfferingVersionHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductOfferingVersionHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductOfferingVersionHistoryQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useProductOfferingVersionHistoryQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ProductOfferingVersionHistoryQuery, ProductOfferingVersionHistoryQueryVariables> & ({ variables: ProductOfferingVersionHistoryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProductOfferingVersionHistoryQuery, ProductOfferingVersionHistoryQueryVariables>(ProductOfferingVersionHistoryDocument, options);
      }
export function useProductOfferingVersionHistoryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProductOfferingVersionHistoryQuery, ProductOfferingVersionHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProductOfferingVersionHistoryQuery, ProductOfferingVersionHistoryQueryVariables>(ProductOfferingVersionHistoryDocument, options);
        }
// @ts-ignore
export function useProductOfferingVersionHistorySuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ProductOfferingVersionHistoryQuery, ProductOfferingVersionHistoryQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProductOfferingVersionHistoryQuery, ProductOfferingVersionHistoryQueryVariables>;
export function useProductOfferingVersionHistorySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProductOfferingVersionHistoryQuery, ProductOfferingVersionHistoryQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProductOfferingVersionHistoryQuery | undefined, ProductOfferingVersionHistoryQueryVariables>;
export function useProductOfferingVersionHistorySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProductOfferingVersionHistoryQuery, ProductOfferingVersionHistoryQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ProductOfferingVersionHistoryQuery, ProductOfferingVersionHistoryQueryVariables>(ProductOfferingVersionHistoryDocument, options);
        }
export type ProductOfferingVersionHistoryQueryHookResult = ReturnType<typeof useProductOfferingVersionHistoryQuery>;
export type ProductOfferingVersionHistoryLazyQueryHookResult = ReturnType<typeof useProductOfferingVersionHistoryLazyQuery>;
export type ProductOfferingVersionHistorySuspenseQueryHookResult = ReturnType<typeof useProductOfferingVersionHistorySuspenseQuery>;
export type ProductOfferingVersionHistoryQueryResult = ApolloReactCommon.QueryResult<ProductOfferingVersionHistoryQuery, ProductOfferingVersionHistoryQueryVariables>;
export const ProductOfferingVersionTlivDetailsDocument = gql`
    query ProductOfferingVersionTlivDetails($id: ID!) {
  readyPlanAggregateVersion(id: $id) {
    id
    tliVersions {
      ...ProductOfferingTlivDetails
    }
  }
}
    ${ProductOfferingTlivDetailsFragmentDoc}`;

/**
 * __useProductOfferingVersionTlivDetailsQuery__
 *
 * To run a query within a React component, call `useProductOfferingVersionTlivDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductOfferingVersionTlivDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductOfferingVersionTlivDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useProductOfferingVersionTlivDetailsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ProductOfferingVersionTlivDetailsQuery, ProductOfferingVersionTlivDetailsQueryVariables> & ({ variables: ProductOfferingVersionTlivDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProductOfferingVersionTlivDetailsQuery, ProductOfferingVersionTlivDetailsQueryVariables>(ProductOfferingVersionTlivDetailsDocument, options);
      }
export function useProductOfferingVersionTlivDetailsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProductOfferingVersionTlivDetailsQuery, ProductOfferingVersionTlivDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProductOfferingVersionTlivDetailsQuery, ProductOfferingVersionTlivDetailsQueryVariables>(ProductOfferingVersionTlivDetailsDocument, options);
        }
// @ts-ignore
export function useProductOfferingVersionTlivDetailsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ProductOfferingVersionTlivDetailsQuery, ProductOfferingVersionTlivDetailsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProductOfferingVersionTlivDetailsQuery, ProductOfferingVersionTlivDetailsQueryVariables>;
export function useProductOfferingVersionTlivDetailsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProductOfferingVersionTlivDetailsQuery, ProductOfferingVersionTlivDetailsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProductOfferingVersionTlivDetailsQuery | undefined, ProductOfferingVersionTlivDetailsQueryVariables>;
export function useProductOfferingVersionTlivDetailsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProductOfferingVersionTlivDetailsQuery, ProductOfferingVersionTlivDetailsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ProductOfferingVersionTlivDetailsQuery, ProductOfferingVersionTlivDetailsQueryVariables>(ProductOfferingVersionTlivDetailsDocument, options);
        }
export type ProductOfferingVersionTlivDetailsQueryHookResult = ReturnType<typeof useProductOfferingVersionTlivDetailsQuery>;
export type ProductOfferingVersionTlivDetailsLazyQueryHookResult = ReturnType<typeof useProductOfferingVersionTlivDetailsLazyQuery>;
export type ProductOfferingVersionTlivDetailsSuspenseQueryHookResult = ReturnType<typeof useProductOfferingVersionTlivDetailsSuspenseQuery>;
export type ProductOfferingVersionTlivDetailsQueryResult = ApolloReactCommon.QueryResult<ProductOfferingVersionTlivDetailsQuery, ProductOfferingVersionTlivDetailsQueryVariables>;